import { SocketContext, SocketContextType } from '@contexts/socket-context';
import { useContext } from 'react';

export function useSocket(): SocketContextType {
    return useContext(SocketContext);
}
